// extracted by mini-css-extract-plugin
export default {"main":"MoopLayout_main__ifpwC","content":"MoopLayout_content__VXoT9"};